import { Component, ElementRef, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LoaningService } from "../../../../common/services/loaning/loaning.service";
import { finalize } from "rxjs/operators";
import { SubSink } from "@Common/core/utils/subsink";
import {Loaning, Scan} from "../../../../common/services/loaning/loaning.model";
import {SnackBarToastyService, typeToast} from "@Common/widgets/general/snack-bar";
import * as FileSaver from "file-saver";
import {PubSubService} from "@Common/core/services";

@Component({
  selector: 'app-upload-scan',
  templateUrl: './upload-scan.component.html',
  styleUrls: ['./upload-scan.component.scss']
})
export class UploadScanDialogComponent implements OnInit {
  scans: Scan[] = [];
  scansFromDb: Scan[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;
  private subSink = new SubSink();
  requiredFileTypes = ['.jpeg', '.pdf', '.jpg', '.png'];
  maxFileSize = 20 * 1024 * 1024; // 20 Mo
  uploadProgress = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UploadScanDialogComponent>,
    private pubSubService: PubSubService,
    private loaningService: LoaningService,
    private snakeSvc: SnackBarToastyService,
  ) {}

  ngOnInit(): void {
    this.getLoaningUpdated();
  }

  getLoaningUpdated(): void {
    this.subSink.sink = this.loaningService.getLoaningById(this.data.uuid).subscribe({
      next: (response: Loaning) => {
        this.data = response;
        this.scansFromDb = this.mapScans(response.scans_obj);
      },
      error: (err) => {
        console.error('Error fetching scans:', err);
      }
    });
  }

  downloadSingleScan(scan) {
    this.pubSubService.publish('loading', true);
    this.subSink.sink = this.loaningService.downloadSingleScan(scan)
      .pipe(finalize(() => this.pubSubService.publish('loading', false)))
      .subscribe();
  }

  mapScans(scans: any[]): Scan[] {
    return scans
      .map(({ id, file_name, file, loaning }) => ({ id, file_name, file, loaning }))
      .sort((a, b) => b.id - a.id);
  }

  uploadFiles(): void {
    this.uploadProgress = true;
    this.pubSubService.publish('loading', true);
    this.subSink.sink = this.loaningService.uploadScanConsultation(this.scans)
      .pipe(finalize(() => {
        this.uploadProgress = false;
        this.pubSubService.publish('loading', false);
      }))
      .subscribe({
        next: () => {
          this.scans = [];
          this.getLoaningUpdated();
        },
        error: (err) => {
          console.error('HTTP Error:', err);
        }
      });
  }
  onFileSelected(event: Event): void {
    const selectedFiles = (event.target as HTMLInputElement).files;
    if (!selectedFiles?.length) {
      return;
    }

    Array.from(selectedFiles).forEach(file => {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

      // Vérification du type de fichier
      if (!this.requiredFileTypes.includes(fileExtension)) {
        const erMsg = `Le fichier ${file.name} n'est pas autorisé. Formats acceptés : ${this.requiredFileTypes.join(', ')}`;
        this.snakeSvc.toasty('Demande de consultation', erMsg, typeToast.warning, 5000);
        return;
      }

      // Vérification de la taille du fichier
      if (file.size > this.maxFileSize) {
        const erMsg = `Le fichier ${file.name} est trop volumineux. La taille maximale autorisée est de 50 Mo.`;
        this.snakeSvc.toasty('Demande de consultation', erMsg, typeToast.warning, 5000);
        return;
      }

      // Ajout du fichier valide
      this.scans.push({ file, file_name: file.name, loaning: this.data.id });
    });
  }

  removeFile(index: number, scanId?: number): void {
    const removedScan = scanId ? this.scansFromDb.splice(index, 1)[0] : this.scans.splice(index, 1)[0];

    if (scanId) {
      this.subSink.sink = this.loaningService.deleteFile(scanId).subscribe({
        next: () => {
          this.data.scans_obj = this.scansFromDb;
        },
        error: (err) => {
          console.error('Error deleting file:', err);
          this.scansFromDb.splice(index, 0, removedScan);
          this.data.scans_obj = [...this.scansFromDb];
        }
      });
    }

    this.fileInput.nativeElement.value = '';
  }

  onCloseClick(): void {
    this.subSink.unsubscribe();
    this.dialogRef.close(this.data);
  }

}
